export default __webpack_public_path__ + "static/media/paper.669e99a5.png";